import React from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";

import HomeScreen from "./pages/HomeScreen";
import ProductScreen from "./pages/ProductScreen";
import CartScreen from "./pages/CartScreen";
import LoginScreen from "./pages/LoginScreen";
import RegisterScreen from "./pages/RegisterScreen";
import ProfileScreen from "./pages/ProfileScreen";
import PaymentScreen from "./pages/PaymentScreen";
import UserListScreen from "./pages/admin/UserListScreen";
import UserEditScreen from "./pages/admin/UserEditScreen";
import ProductListScreen from "./pages/admin/ProudctListScreen";
import ProductEditScreen from "./pages/admin/ProductEditScreen";
import CategoryListScreen from "./pages/admin/CategoryListScreen";
import CategoryEditScreen from "./pages/admin/CategoryEditScreen";
import SubCategoryListScreen from "./pages/admin/SubCategoryListScreen";
import SubCategoryEditScreen from "./pages/admin/SubCategoryEditScreen";
import CategoryScreen from "./pages/CategoryScreen";
import DashboardScreen from "./pages/admin/DashboardScreen";
import UserLayout from "./components/UserLayout";
import AdminLayout from "./components/admin/AdminLayout";
import ScreenShotScreen from "./pages/ScreenShotScreen";
import SendMessangerScreen from "./pages/SendMessangerScreen";
import FeaturedListScreen from "./pages/admin/FeaturedListScreen";
import FeaturedEditScreen from "./pages/admin/FeaturedEditScreen";
import MaintainScreen from "./pages/MaintainScreen";

function App() {
  return (
    <Router>
      <Route path="/" component={MaintainScreen} exact />
    </Router>
  );
}

export default App;
